import { Suspense } from 'react'
import { RouterProvider } from "react-router-dom"
import { HelmetProvider } from 'react-helmet-async'
import Routes from './Routes'

const App = () => {
  return (
    <HelmetProvider>
      <Suspense fallback={<div />}>
        <RouterProvider router={Routes} />
      </Suspense>
    </HelmetProvider>
  )
}

export default App
